/**
 * InformationBoxField.tsx
 *
 * Displays informational text (non-interactive field)
 */

import React from 'react';
import { BaseFieldProps } from './shared/types';

export const InformationBoxField: React.FC<BaseFieldProps> = React.memo(({
  fieldConfig,
}) => {
  const infoText = fieldConfig.description || fieldConfig.label || '';

  return (
    <div className="flex items-start gap-2 w-full mb-4">
      <span className="text-sm text-muted-foreground whitespace-pre-wrap break-words">
        {infoText}
      </span>
    </div>
  );
});

InformationBoxField.displayName = 'InformationBoxField';
